import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { ListResultResponse } from '../../../../../../common/dist/angular/responses/list-result.response';
import { EventModel } from '../../../../../../common/dist/angular/models/event.model';
import { map, switchMap } from 'rxjs/operators';
import { TransformerClassType } from '../../../../modules/src/lib/core/interceptors/transformer.http-interceptor';
import { SearchQuery } from '../../../../../../server/dist/angular/server/src/microservice/models/search-query.model';
import { SearchResult } from '../../../../../../common/src/models/search-result.model';
import { EventIndexModel } from '../../../../../../common/src/index-models/event.index-model';
import { DataMapper } from '@pristine-ts/data-mapping-common';
import { BaseApiController } from './base.api-controller';
import { EnvironmentManager } from '../../../../modules/src/lib/core/managers/environment.manager';

@Injectable()
export class EventApiController extends BaseApiController {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly dataMapper: DataMapper,
    environmentManager: EnvironmentManager,
  ) {
    super(environmentManager);
  }

  public async get(id: string): Promise<EventModel<any>> {
    return this.httpClient.get<EventModel<any>>(`${this.getApiUrl()}/api/events/${id}`, {
      context: new HttpContext().set(TransformerClassType, EventModel),
    }).toPromise();
  }

  public async list(pageSize: number, startKey?: any): Promise<EventModel<any>[]> {
    let queryParams = new HttpParams();
    queryParams = queryParams.set('pageSize', pageSize);
    if (startKey) {
      queryParams = queryParams.set('startKey', JSON.stringify(startKey));
    }
    return this.httpClient.get<ListResultResponse<EventModel<any>>>(`${this.getApiUrl()}/api/events`, {
      params: queryParams,
      context: new HttpContext().set(TransformerClassType, EventModel<any>),
    }).pipe(
      map((result) => result.items),
    ).toPromise();
  }

  public async search(searchQuery: SearchQuery): Promise<SearchResult<EventIndexModel<any>>> {
    return this.httpClient.get<SearchResult<EventIndexModel<any>>>(`${this.getApiUrl()}/api/events/_search?${(new HttpParams({ fromObject: JSON.parse(JSON.stringify(searchQuery.exportQueryParameters())) })).toString()}`)
      .pipe(
        switchMap(async (response: SearchResult<EventIndexModel<any>>) => {
          for (let i = 0; i < response.results.length; i++) {
            response.results[i] = await this.dataMapper.autoMap(response.results[i], EventIndexModel);
          }

          return response;
        }),
      ).toPromise();
  }

  // private static map(eventModel: EventModel<any>) {
  //     return {
  //         ...eventModel,
  //         createdAt: new Date(eventModel.createdAt),
  //     }
  // }
}
